<template>
  <v-row class="pr-1">
    <v-col cols="12" md="7" class="left-area pa-1">
      <v-card-text>
        <div class="d-flex align-center">
          <div class="subtitle-1 font-weight-bold">메시지 상태</div>
          <span class="ml-5"><v-icon small :color="msg_status_color">mdi-checkbox-blank-circle</v-icon>{{ getMsgText(msg_status) }}</span>
        </div>
        <div class="mt-3">
          <div class="title d-flex justify-space-between mb-2 ">
            <span class="subtitle-1 font-weight-bold">메시지 내용</span>
            <div v-if="!is_manual">
              <v-btn small outlined color="grey lighten-3" class="grey lighten-3 text--darken-3 mr-2" @click="initContentText"
                >기본 메시지 적용</v-btn
              >
              <v-menu offset-y transition="slide-y-transition">
                <template v-slot:activator="{ on }">
                  <v-btn small outlined color="grey lighten-3" class="grey lighten-3 text--darken-3" v-on="on">#변수 추가</v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in add_text_list" :key="index" link>
                    <v-list-item-title @click="addContentValue(item.text)">{{ item.desc }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
          <v-textarea v-model="msg_content" outlined hide-details="false" height="200px" class="msg_content"></v-textarea>
          <div class="d-flex justify-end text-xs mt-2">
            [ <span class="blue--text"> {{ msg_content.length }}</span> / 1,000 ]
          </div>
        </div>
      </v-card-text>
      <div>
        <v-card-text class="py-0 ">
          <div class="subtitle-1 font-weight-bold">버튼</div>
          <v-radio-group v-model="msg_use_button" row>
            <v-radio value="YES" class="black--text mr-10">
              <template v-slot:label>
                <div class="black--text">사용함</div>
              </template>
            </v-radio>
            <v-radio value="NO">
              <template v-slot:label>
                <div class="black--text">사용안함</div>
              </template>
            </v-radio>
          </v-radio-group>
          <div v-if="msg_use_button == 'YES'">
            <v-select v-model="msg_button_type" :items="button_list" outlined dense hide-details="false"></v-select>
            <v-card-subtitle class="black--text pl-0 pb-0">버튼 이름</v-card-subtitle>
            <v-text-field
              v-model="msg_button_name"
              outlined
              dense
              hide-details="false"
              placeholder="버튼 이름을 입력해주세요."
            ></v-text-field>
            <v-card-subtitle class="black--text pl-0 pb-0">Mobile</v-card-subtitle>
            <v-text-field
              v-model="msg_button_mobile_url"
              outlined
              dense
              hide-details="false"
              placeholder="http(s)://url 링크를 입력해 주세요."
            ></v-text-field>
            <v-card-subtitle class="black--text pl-0 pb-0">PC</v-card-subtitle>
            <v-text-field
              v-model="msg_button_pc_url"
              outlined
              dense
              hide-details="false"
              placeholder="http(s)://url 링크를 입력해 주세요."
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-text v-if="msg_use_button == 'YES' && msg_button_type == 'app_link'" class="pt-0">
          <v-card-subtitle class="black--text pl-0 pb-0">Android</v-card-subtitle>
          <v-text-field
            v-model="msg_button_Android_url"
            outlined
            dense
            hide-details="false"
            placeholder="Custom Scheme://url 링크를 입력해 주세요. 미입력시 모바일 링크로 대체됩니다."
          ></v-text-field>
          <v-card-subtitle class="black--text pl-0 pb-0">iOS</v-card-subtitle>
          <v-text-field
            v-model="msg_button_IOS_url"
            outlined
            dense
            hide-details="false"
            placeholder="Custom Scheme://url 링크를 입력해 주세요. 미입력시 모바일 링크로 대체됩니다."
          ></v-text-field>
        </v-card-text>
      </div>
    </v-col>

    <v-col cols="12" md="5" class="right-area pl-0">
      <v-card class="preview px-2" outlined>
        <v-card-subtitle class="font-weight-bold black--text">미리보기</v-card-subtitle>
        <v-card-text class="preview_area">
          <div class="preview_content">
            <v-card-subtitle color="yellow" class="yellow black--text">알림톡 도착</v-card-subtitle>
            <div>
              <v-card-text v-html="changePreviewContent(msg_content)"></v-card-text>
              <div v-if="msg_use_button == 'YES'" class="preview_btn">{{ msg_button_name ? msg_button_name : " " }}</div>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <div class="mt-2 text-xs">
        <ul class="grey--text ">
          <li>
            검수 요청한 메시지는 카카오의 검수가 필요해요(평균 3~5일소요)
          </li>
          <li>
            문구, 버튼, URL 링크 등 메시지를 수정하면 검수가 완료되어야 고객에게 발송할 수 있어요. 수정 후 ‘검수 요청’ 버튼을 눌러주세요.
          </li>
        </ul>
        <a class="ml-6" href="https://kakaobusiness.gitbook.io/main/ad/infotalk/audit" target="_blank"
          >카카오톡 알림톡 제작가이드 참고</a
        >
      </div>
    </v-col>
    <v-col cols="12" class="d-flex justify-space-between pa-4 pb-0 mt-6">
      <v-btn class="kakao_set_btn" dark @click="closeModal">닫기</v-btn>
      <v-btn class="kakao_set_btn info" @click="saveSettings">임시 저장</v-btn>
      <v-btn color="yellow" class="kakao_set_btn black--text" @click="requestKakaoTemplate">카카오톡 검수 요청</v-btn>
    </v-col>
  </v-row>
</template>

<style>
.kakao_set_btn {
  width: 32%;
  margin-top: 10px;
}

.msg_content {
  font-size: 1em;
}

.msg_content textarea {
  margin-top: 0px !important;
  padding-top: 10px;
}

.preview_btn {
  background: #f5f5f5;
  border: 1px solid #dadada;
  border-radius: 10px;
  margin: 10px;
  padding: 10px;
  margin-top: 10px;
  text-align: center;
}

.preview_content {
  margin-top: 16px;
  border: 1px solid #dadada;
  border-radius: 10px;
  background: #fff;
}

.preview_content .yellow {
  background: #fae64c;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  border-bottom: 1px solid #dadada;
  padding: 10px;
  padding-left: 15px;
}

.preview_area {
  width: auto !important;
  border: 2px solid #dadada;
  padding: 10px;
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;
  margin-left: 12px;
  margin-right: 12px;
  background: #bfd1db;
}
</style>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
export default {
  data() {
    return {
      template_code: null,
      msg_status: "", // awaiting, checking, completed
      msg_status_color: "blue",
      msg_content: "",
      msg_use_button: "YES",
      msg_button_type: "web_link",
      msg_button_name: "",
      msg_button_mobile_url: "",
      msg_button_pc_url: "",
      msg_button_Android_url: "",
      msg_button_IOS_url: "",
      button_list: [
        { text: "웹 링크", value: "web_link" },
        { text: "앱 링크", value: "app_link" },
      ],
      add_text_list: null,
      sample_content_data: this.getSampleData(),
    };
  },
  mixins: [CommonMixin],
  props: {
    msg_type: {
      type: String,
      required: true,
    },
    msg_title: {
      type: String,
      required: true,
    },
    is_manual: {
      type: Boolean,
      default: false,
    },
  },
  created: function() {
    this.resetKakaoDetailSetting();
  },
  watch: {
    msg_type: function() {
      this.resetKakaoDetailSetting();
    },
  },
  methods: {
    resetKakaoDetailSetting() {
      this.msg_status = "등록";
      this.msg_content = this.getInitContentText(this.msg_type);
      //this.template_code = null;
      this.msg_use_button = "YES";
      this.msg_button_type = "web_link";
      this.msg_button_name = "";
      this.msg_button_mobile_url = "";
      this.msg_button_pc_url = "";
      this.msg_button_Android_url = "";
      this.msg_button_IOS_url = "";
      this.add_text_list = this.getUserTagList(this.getIsOrderMessage(this.msg_type), this.getAbleSerialTag(this.msg_type));
      this.getKakaotalkDetail();
      if (["buyed_confirm", "shipping_end"].includes(this.msg_type)) {
        this.getCheckTag(this.msg_type);
        this.applyQrUrlFilter(this.msg_type);
      }
    },
    // 2026-07-25: 자동 생성 설정과 매칭되지 않는 msg_type 에서는 REGISTRATION_QR_URL 태그 제거.
    //   auto_generate_event=shipping_done → buyed_confirm 에서 태그 제거
    //   auto_generate_event=purchase_confirmed → shipping_end 에서 태그 제거
    //   auto_generate_event=none → 둘 다 허용 (중복 방지는 별도 getUseTypeByTag)
    applyQrUrlFilter: async function(chk_type) {
      const qr_tag = "#{REGISTRATION_QR_URL}";
      const autoGenerateEvent = await this.getAutoGenerateEvent(M);
      if (!this.isQrUrlAllowedForMsgType(chk_type, autoGenerateEvent)) {
        this.add_text_list = this.add_text_list.filter((tag) => tag.text !== qr_tag);
        return;
      }
      // 다른 msg_type 이 이미 사용 중이면 제거 (중복 방지)
      const used = await this.getUseTypeByTag(M, qr_tag, chk_type);
      if (used) {
        this.add_text_list = this.add_text_list.filter((tag) => tag.text !== qr_tag);
      }
    },
    getKakaotalkDetail: async function() {
      try {
        const res = await M.api(M.entry("/get/message/detail/kakao"), { msg_type: this.msg_type });
        if (res) {
          if (res.template_content.length > 0) {
            this.msg_status = res.kakao_status;
            this.msg_content = res.template_content;
            /*
            if (res.template_code) {
              this.template_code = res.template_code;
            }
            this.template_code = res.template_code;
            */
            this.msg_button_name = res.button_name;
            if (res.button_type) {
              this.msg_use_button = "YES";
              this.msg_button_type = res.button_type;
              this.msg_button_mobile_url = res.button_mobile_url;
              this.msg_button_pc_url = res.button_pc_url;
              if (this.msg_button_type === "app_link") {
                this.msg_button_Android_url = res.button_android_url;
                this.msg_button_IOS_url = res.button_ios_url;
              }
            } else {
              this.msg_use_button = "NO";
            }
          }
        }
      } catch (err) {
        console.log("get kakao detail error", err);
      }
    },
    getCheckTag: async function(chk_type) {
      const check_tag = "#{SERIAL_CODE}";
      try {
        const chk = await this.getUseTypeByTag(M, check_tag, chk_type);
        if (chk) {
          this.add_text_list = this.add_text_list.filter((tag) => tag.text !== check_tag);
        }
      } catch (err) {
        console.log("get check tag", err);
      }
    },
    closeModal() {
      this.$emit("close");
    },
    setKakaoTemplateContent: async function(set_data) {
      const check_tag = "#{SERIAL_CODE}";
      if (this.isTagUsed(set_data.template_content, check_tag)) {
        if (await this.getUseTypeByTag(M, check_tag, this.msg_type)) {
          alert(
            "시리얼코드(미인증 코드 발송) 변수는 \n중복코드 발송 방지를 위해 배송완료 또는 구매확정 상태 발송시 1번만 발송이 가능합니다.\n해당 변수가 이미 추가된 상태이므로 삭제 후 설정해주세요.",
          );
          this.msg_content = this.msg_content.replace(check_tag, "");
          return false;
        }
      }
      const qr_tag = "#{REGISTRATION_QR_URL}";
      if (this.isTagUsed(set_data.template_content, qr_tag)) {
        const autoGenerateEvent = await this.getAutoGenerateEvent(M);
        if (!this.isQrUrlAllowedForMsgType(this.msg_type, autoGenerateEvent)) {
          const allowedLabel = autoGenerateEvent === "shipping_done" ? "배송완료" : autoGenerateEvent === "purchase_confirmed" ? "구매확정" : "";
          alert(
            "쇼핑몰 정품 QR 링크 변수는\n자동 생성 설정과 일치하는 상태 발송에만 사용할 수 있습니다." +
              (allowedLabel ? `\n\n현재 자동 생성 설정: ${allowedLabel} → ${allowedLabel} 상태 발송에서만 사용 가능합니다.` : "") +
              "\n해당 변수가 이미 추가된 상태이므로 삭제 후 설정해주세요.",
          );
          this.msg_content = this.msg_content.replace(qr_tag, "");
          return false;
        }
        if (await this.getUseTypeByTag(M, qr_tag, this.msg_type)) {
          alert(
            "쇼핑몰 정품 QR 링크 변수는\n중복 방지를 위해 배송완료 또는 구매확정 상태 발송 중 1번만 사용할 수 있습니다.\n해당 변수가 이미 추가된 상태이므로 삭제 후 설정해주세요.",
          );
          this.msg_content = this.msg_content.replace(qr_tag, "");
          return false;
        }
      }
      const res = await M.api(M.entry("/put/message/detail/kakao"), set_data);
      if (res) {
        return true;
      }
    },
    requestKakaoTemplate: async function() {
      if (this.msg_status === "심사요청") {
        if (
          !confirm(
            "카카오톡 검수 중 상태입니다.\n현재 작성된 메시지로 새롭게 검수 요청을 하시겠습니까?\n새롭게 검수 요청시 심사에 따라 평균 3~5일 정도 소요되며,\n메시지 상태가 검수 완료로 변경되면 발송이 가능합니다.",
          )
        ) {
          return;
        }
      } else if (this.msg_status === "승인") {
        if (
          !confirm(
            "카카오톡 검수 완료된 상태입니다.\n현재 작성된 메시지로 새롭게 검수 요청을 하시겠습니까?\n새롭게 검수 요청시 심사에 따라 평균 3~5일 정도 소요되며,\n메시지 상태가 검수 완료로 변경되면 발송이 가능합니다",
          )
        ) {
          return;
        }
      }
      if (!this.validateInput()) {
        return;
      }
      const set_data = this.getSetData();
      // 카카오톡 검수 요청시 필요한 추가 값 체크
      try {
        const save_res = await this.setKakaoTemplateContent(set_data);
        if (save_res) {
          const res = await M.api(M.entry("/put/message/detail/kakao_request"), set_data);
          if (res) {
            if (res.code === 0) {
              this.msg_status = "심사요청";
              this.alertShow(
                "카카오톡 검수 요청되었습니다.\n검수 요청시 심사에 따라 평균 3~5일 정도 소요되며,\n메시지 상태가 검수 완료로 변경되면 발송이 가능합니다.",
              );
              return false;
              //this.template_code = res.template_code;
            }
          }
        }
      } catch (err) {
        console.log("request kakao template error", err);
      }
    },
    validateInput() {
      if (this.msg_content.trim() === "") {
        this.alertShow("메시지 내용을 입력해주세요.");
        return false;
      }
      if (this.msg_use_button === "YES") {
        if (this.msg_button_name.trim() === "") {
          this.alertShow("버튼 이름을 입력해주세요.");
          return false;
        }
        // 2026-07-24: 카카오 알림톡 button URL 은 http(s):// 로 시작하는 실 URL 만 허용.
        // #{REGISTRATION_QR_URL} 등 변수만 넣으면 aligo 검수 code 511 실패. UI 에서 사전 차단.
        const validateUrl = (label, url) => {
          const v = (url || "").trim();
          if (!v) {
            this.alertShow(label + " URL을 입력해주세요.");
            return false;
          }
          if (/#\{[^}]+\}/.test(v) && !/^https?:\/\//i.test(v)) {
            this.alertShow(label + " URL 은 http(s):// 로 시작하는 실제 링크만 입력 가능합니다.\n#{변수} 만 사용할 수 없습니다.");
            return false;
          }
          if (!/^https?:\/\//i.test(v)) {
            this.alertShow(label + " URL 은 http:// 또는 https:// 로 시작해야 합니다.");
            return false;
          }
          return true;
        };
        if (!validateUrl("Mobile", this.msg_button_mobile_url)) return false;
        if (!validateUrl("PC", this.msg_button_pc_url)) return false;
        if (this.msg_button_type === "app_link") {
          if (!validateUrl("Android", this.msg_button_Android_url)) return false;
          if (!validateUrl("iOS", this.msg_button_IOS_url)) return false;
        }
      }
      return true;
    },
    getSetData: function() {
      let data = {
        msg_type: this.msg_type,
        template_name: this.msg_title,
        template_title: this.msg_title,
        template_content: this.msg_content,
        button_status: this.msg_use_button === "YES" ? "enabled" : "disabled",
      };
      /*
      if (this.template_code) {
        data = {
          ...data,
          template_code: this.template_code,
        };
      }
        */
      if (this.msg_use_button === "YES") {
        data = {
          ...data,
          button_type: this.msg_button_type,
          button_name: this.msg_button_name,
          button_mobile_url: this.msg_button_mobile_url,
          button_pc_url: this.msg_button_pc_url,
        };

        if (this.msg_button_type === "app_link") {
          data = {
            ...data,
            button_android_url: this.msg_button_Android_url,
            button_ios_url: this.msg_button_IOS_url,
          };
        }
      }
      return data;
    },
    saveSettings: async function() {
      if (!this.validateInput()) {
        return;
      }
      const set_data = this.getSetData();
      try {
        const res = await this.setKakaoTemplateContent(set_data);
        // console.log("save return ", res);
        if (res) {
          // console.log("save kakao detail setting", res);
          this.alertShow(
            "메시지 내용이 저장되었습니다.\n해당 내용으로 카카오톡 메시지 발송을 하시려면\n ‘카카오톡 검수 요청’ 버튼을 클릭해주세요.",
          );
          //this.template_code = res.template_code;
        }
      } catch (err) {
        console.log("save kakao settings error", err);
      }
    },
    addContentValue: function(text) {
      this.msg_content += text;
    },
    changePreviewContent: function(content) {
      let result = content;
      for (let key in this.sample_content_data) {
        result = result.split(key).join(this.sample_content_data[key]);
      }
      return result.replace(/\n/g, "<br>");
    },
    getMsgText: function(status) {
      switch (status) {
        case "심사요청":
          this.msg_status_color = "yellow";
          return " 검수 중";
        case "승인":
          this.msg_status_color = "blue";
          return " 검수 완료";
        case "반려":
          this.msg_status_color = "red";
          return " 반려";
        case "등록":
        default:
          this.msg_status_color = "grey";
          return " 검수 전";
      }
    },
    initContentText() {
      if (confirm("기본 제공하는 메시지 문구로 변경되어요.\n진행하시겠습니까?")) {
        this.msg_content = this.getInitContentText(this.msg_type);
      }
    },
  },
};
</script>
